import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuditLog } from '../../../../models/auditLog';
import { AuditLogService } from '../../../../services/audit-log.service';
import { ChangeRow, parseAuditChanges } from '../../../../utilities/auditLogChanges';

/** One entry of the change set, with its field-level diff already parsed for display. */
interface EntryView {
  entry: AuditLog;
  rows: ChangeRow[];
  parseError: boolean;
  rawChanges: string;
}

/** Data passed in by the list: the clicked row, used for the change-set id and shared header info. */
export interface AuditLogChangeSetDialogData {
  changeSetId: string;
  changedBy: string;
  changedAt: string;
}

@Component({
  selector: 'app-audit-log-change-set-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './audit-log-change-set-dialog.component.html',
  styleUrl: './audit-log-change-set-dialog.component.scss'
})
export class AuditLogChangeSetDialogComponent implements OnInit {
  readonly displayedColumns = ['field', 'old', 'new'];

  entries: EntryView[] = [];
  loading = true;
  loadError = false;

  constructor(
    public dialogRef: MatDialogRef<AuditLogChangeSetDialogComponent>,
    private auditLogService: AuditLogService,
    @Inject(MAT_DIALOG_DATA) public data: AuditLogChangeSetDialogData
  ) {}

  ngOnInit(): void {
    this.auditLogService.getChangeSet(this.data.changeSetId).subscribe({
      next: (logs) => {
        this.entries = logs.map((entry) => {
          const parsed = parseAuditChanges(entry.changes);
          return { entry, rows: parsed.rows, parseError: parsed.parseError, rawChanges: entry.changes ?? '' };
        });
        this.loading = false;
      },
      error: () => {
        this.loadError = true;
        this.loading = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
